import { OPEN_COMPETENCY_SIDE_PANEL, CLOSE_COMPETENCY_SIDE_PANEL } from 'actions/actionTypes';

export const closeCompetencySidePanelAction = () => ({
  type: CLOSE_COMPETENCY_SIDE_PANEL,
});

export const openCompetencySidePanelAction = ({
  tagTitle,
  tagDescription = '',
  tagId,
  employeeId,
  onClose = () => {},
  hideShareFeedbackButtons = false,
}) => ({
  type: OPEN_COMPETENCY_SIDE_PANEL,
  tagTitle,
  tagDescription,
  tagId,
  employeeId,
  onClose,
  hideShareFeedbackButtons,
});
